export default [
  {
    path: '/objects',
    name: 'objects',
    component: () => import('@/views/modules/Warehouse/objects/index.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'warehouses',
          active: true,
        },
        {
          text: 'objects__ob',
          active: true,
        },
    ],
    },
  },
  {
    path: '/objects/view-warehouse/:id',
    name: 'objects-view-warehouse',
    component: () => import('@/views/modules/Warehouse/objects/components/ViewObjects.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'warehouses',
          to: '/objects',
          active: false,
        },
        {
          text: 'objects__ob',
          active: true,
        },
        {
          text: 'warehouse_view',
          active: true,
        },
      ],
    },
  },
  {
    path: '/masters',
    name: 'masters',
    component: () => import('@/views/modules/Warehouse/masters/index.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'warehouses',
          active: true,
        },
        {
          text: 'sidebar.masters',
          active: true,
        },
    ],
    },
  },
  {
    path: '/masters/view-warehouse/:id',
    name: 'masters-view-warehouse',
    component: () => import('@/views/modules/Warehouse/masters/components/ViewMasters.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'warehouses',
          to: '/masters',
          active: false,
        },
        {
          text: 'sidebar.masters',
          active: true,
        },
        {
          text: 'warehouse_view',
          active: true,
        },
      ],
    },
  },
  {
    path: '/remains',
    name: 'remains',
    component: () => import('@/views/modules/Warehouse/remains/index.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'warehouses',
          active: true,
        },
        {
          text: 'sidebar.remains',
          active: true,
        },
      ],
    },
  },
  {
    path: '/remains/view-remains/:id',
    name: 'remains-view-remains',
    component: () => import('@/views/modules/Warehouse/remains/components/detail.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'warehouses',
          to: '/remains',
          active: false,
        },
        {
          text: 'sidebar.remains',
          active: true,
        },
        {
          text: 'warehouse_view',
          active: true,
        },
      ],
    },
  },
]
